import UserInvitesService from '@/services/users/user-invites-service'

export const state = {
  token: {
    validated: false,
    valid: false
  },
  confirmation: {},
  userInvite: {},
  loading: {
    token: false,
    confirmation: false
  }
}

export const getters = {}

export const actions = {
  validateInviteToken({ commit }, token) {
    commit('SET_TOKEN_LOADING', true)

    UserInvitesService.validateToken(token)
      .then(response => {
        commit('SET_TOKEN_VALID', true)
        commit('SET_USER_INVITE', response.data)
      })
      .catch(() => {})
      .then(() => {
        commit('SET_TOKEN_LOADING', false)
        commit('SET_TOKEN_VALIDATED', true)
      })
  },
  confirmUserInvite({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_CONFIRMATION_LOADING', true)

      UserInvitesService.confirmInvite(payload)
        .then(response => {
          dispatch(
            'auth/login',
            {
              email: response.data.email,
              password: payload.password
            },
            { root: true }
          ).then(() => {
            resolve()
          })
        })
        .catch(() => {
          reject()
        })
        .then(() => {
          commit('SET_CONFIRMATION_LOADING', false)
        })
    })
  }
}

export const mutations = {
  SET_TOKEN_LOADING(state, loading) {
    state.loading.token = loading
  },
  SET_CONFIRMATION_LOADING(state, loading) {
    state.loading.confirmation = loading
  },
  SET_TOKEN_VALIDATED(state, validated) {
    state.token.validated = validated
  },
  SET_TOKEN_VALID(state, valid) {
    state.token.valid = valid
  },
  SET_USER_INVITE(state, userInvite) {
    state.userInvite = userInvite
  }
}
